import { FunctionComponent } from "react";
import styled from "styled-components";

export const LowiLogoWrapper = styled.svg`
  height: 45px;
  width: 125px;

  .cls-1 {
    fill: #e60000;
  }

  .cls-2 {
    fill: #1f140f;
  }

  path {
    strokewidth: 0px;
  }
`;

const LowiLogo: FunctionComponent = () => (
  <LowiLogoWrapper viewBox="0 0 746.01 234.24" id="icon-lowi-logo">
    <path className="cls-2" d="M26.99 103.341V42.7446H0V127.383H53.9323V103.341H26.99Z" />
    <path
      className="cls-2"
      d="M283.064 42.7447H256.088L238.43 80.7688L214.041 40.8387L189.651 80.7688L171.993 42.7447H145.017L186.969 131.495L214.041 86.9224L241.119 131.495L283.064 42.7447Z"
    />
    <path className="cls-2" d="M290.273 42.7446H317.263V127.383H290.273V42.7446Z" />
    <path
      className="cls-2"
      d="M102.29 62.7504C114.611 62.7504 124.637 72.7772 124.637 85.098C124.637 97.4187 114.611 107.446 102.29 107.446C89.9692 107.446 79.9424 97.4187 79.9424 85.098C79.9424 72.7772 89.9692 62.7504 102.29 62.7504ZM102.29 38.7079C76.6682 38.7079 55.8999 59.4762 55.8999 85.098C55.8999 110.72 76.6682 131.488 102.29 131.488C127.912 131.488 148.68 110.72 148.68 85.098C148.68 59.4762 127.912 38.7079 102.29 38.7079Z"
    />
    <path
      className="cls-1"
      d="M303.765 35.216C313.283 35.216 321 27.4994 321 17.9806C321 8.46169 313.283 0.745117 303.765 0.745117C294.246 0.745117 286.529 8.46169 286.529 17.9806C286.529 27.4994 294.246 35.216 303.765 35.216Z"
    />
  </LowiLogoWrapper>
);

export default LowiLogo;
